import { type RecruitingFormSchema, type RecruitingMutationSchema } from '../schemas';

export function recruitingFormToUpdate({
  profile_image,
  resume,
  additional_documents,
  recruiting_job_categories,
  hiring_criteria_categories,
  phone_numbers,
  recruiting_tags,
  recruiting_status,
  referral,
  ...rest
}: RecruitingFormSchema): RecruitingMutationSchema {
  return {
    ...rest,
    profile_image: profile_image?.map((file) => file.id) ?? [],
    resume: resume?.map((file) => file.id) ?? [],
    additional_documents: additional_documents?.map((file) => file.id) ?? [],
    recruiting_job_categories: recruiting_job_categories?.map((item) => item.id) ?? [],
    hiring_criteria_categories: hiring_criteria_categories?.map((item) => item.id) ?? [],
    phone_numbers: phone_numbers?.map((item) => item.id) ?? [],
    recruiting_tags: recruiting_tags?.map((item) => item.value).join(',') ?? '',
    recruiting_status_id: recruiting_status?.id ?? null,
    referral_id: referral?.id ?? null,
  };
}
